module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("38Axh"))).then(() => parcelRequire('e9QtB'));